"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Scheduler = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var Scheduler = exports.Scheduler = /*#__PURE__*/function () {
  function Scheduler() {
    (0, _classCallCheck2["default"])(this, Scheduler);
  }
  return (0, _createClass2["default"])(Scheduler, [{
    key: "run",
    value:
    /**
     * Runs a generator function concurrently
     * It's a naive implementation that uses setTimeout().
     * @param {() => Generator} callback Generator function to schedule
     */
    function run(callback) {
      var _this = this;
      this.cancel();

      // get generator by calling generator function
      var generator = callback();
      var _runGenerator = function runGenerator() {
        // 10ms budget for running task
        var deadline = performance.now() + 10;
        // start iteration
        while (true) {
          // we get result object for each yield and return
          var result = generator.next();
          if (result.done) {
            // we reached return - no more work to do
            break;
          } else if (performance.now() >= deadline) {
            // we reached deadline - now it's time to schedule the next task
            // and stop the current one
            _this.timeoutId = setTimeout(_runGenerator);
            break;
          }
        }
      };
      // start the generator iteration task
      _runGenerator();
    }

    /**
     * Cancels currently running generator.
     */
  }, {
    key: "cancel",
    value: function cancel() {
      if (this.timeoutId !== undefined) {
        // cancel scheduled task
        clearTimeout(this.timeoutId);
        this.timeoutId = undefined;
      }
    }
  }]);
}();